module.exports = __webpack_public_path__ + "static/media/i8.a5e1b05d.jpg";